import { useClinic } from "@/context/ClinicContext";

/** The clinic's own mark: their logo when they have one, their initial when they don't.
 *
 *  The previous fallback was a lucide pulse/heartbeat glyph, which reads as "hospital" —
 *  wrong for TRT, weight-loss and concierge practices, and wrong for a white-label product
 *  where this tile is the CLINIC's identity and not ours. An initial says nothing except
 *  the clinic's own name, which is the point.
 *
 *  Callers keep their own tile (dark sidebar, primary header, card) and this fills it, so
 *  a clinic that uploads a logo and one that hasn't sit in exactly the same frame.
 *
 *  `name` / `logoUrl` override the context for previews that must reflect unsaved edits.
 */
export default function ClinicMark({ name, logoUrl, className = "" }) {
  const { clinic } = useClinic();
  const label = (name ?? clinic?.name ?? "").trim();
  const src = logoUrl !== undefined ? logoUrl : clinic?.logo_url;

  if (src) {
    return <img src={src} alt={label || "Clinic logo"} data-testid="clinic-logo"
                className={`w-full h-full object-cover ${className}`} />;
  }
  // "•" only if a clinic somehow has no name at all — better than an empty tile.
  const initial = label ? label.charAt(0).toUpperCase() : "•";
  return (
    <span data-testid="clinic-initial"
          className={`font-heading font-bold leading-none select-none ${className}`}>
      {initial}
    </span>
  );
}
